// extracted by mini-css-extract-plugin
export default {"container":"Kp-z","brandName":"Lp-z","productName":"Mp-z","productNamePdpEnhancements":"Np-z","breakLongProductName":"Op-z"};